import type { IconProps } from './types';
import './icons.css';

export default function Chain({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-chain ${className || ''}`}
      fill="none"
    >
      <path
        fill="currentColor"
        d="M12.089 8.81a1 1 0 0 1 1.334-.472 4.75 4.75 0 0 1 1.31 7.646l-3.75 3.75a4.75 4.75 0 0 1-6.716-6.717l1.463-1.464a1 1 0 1 1 1.415 1.414L5.68 14.43a2.75 2.75 0 0 0 3.888 3.89l3.75-3.75a2.752 2.752 0 0 0-.759-4.428 1 1 0 0 1-.471-1.333m4.286-5.935a4.75 4.75 0 0 1 3.358 8.11l-1.463 1.463a1 1 0 1 1-1.415-1.414L18.32 9.57a2.752 2.752 0 0 0-1.944-4.695c-.73 0-1.429.29-1.944.806l-3.75 3.75a2.75 2.75 0 0 0-.767 2.41 2.75 2.75 0 0 0 1.526 2.017 1 1 0 1 1-.863 1.805 4.75 4.75 0 0 1-1.31-7.646l3.75-3.75a4.75 4.75 0 0 1 3.358-1.392"
      />
    </svg>
  );
}
